import Button from "../../Button";
import React, { useContext } from "react";
import ChevronLeft from "../../../Svg/ChevronLeft";
import AngleRightSvg from "../../../Svg/AngleRightSvg";
import AlertContext from "../../../context/AlertContext";
import CreateSchemaTableHooks from "../../../Hooks/CreateSchemaTableHooks";
import EditIconSvg from "../../../Svg/EditIconSvg";
import CodingHeaderAdminSideHooks from "../../../Hooks/CodingPage/CodingHeaderAdminSideHooks";
import Constants from "../../../constants";

export default function SQLNavigator() {
  const Alert = useContext(AlertContext);
  const CodingHeaderAdminSideHks = CodingHeaderAdminSideHooks();

  const { parseCreateTable } = CreateSchemaTableHooks();

  const handlePrevious = () => {
    if (
      Alert.testDetail.currentIndex > 0 &&
      Alert.testDetail.currentIndex <= Alert.testDetail.totalQn - 1
    ) {
      Alert.setTestDetail((prev) => ({
        data: prev.data,
        totalQn: prev.totalQn,
        currentIndex: prev.currentIndex - 1,
        ...(prev.data.sections[0]?.questions[prev.currentIndex - 1] || {}),
        solution:
          prev.data.sections[0]?.questions[prev.currentIndex - 1].solution ||
          "",
        schema: parseCreateTable(
          prev.data.sections[0]?.questions[prev.currentIndex - 1].dbSchema,
        ),
        language: [
          {
            value: 1,
            label: "SQL",
          },
        ],
        selectedLanguage: {
          value: 1,
          label: "SQL",
        },
      }));
    }
  };

  const handleNext = () => {
    if (Alert.testDetail.currentIndex < Alert.testDetail.totalQn - 1) {
      Alert.setTestDetail((prev) => ({
        currentIndex: prev.currentIndex + 1,
        data: prev.data,
        totalQn: prev.totalQn,
        ...(prev.data.sections[0]?.questions[prev.currentIndex + 1] || {}),
        schema: parseCreateTable(
          prev.data.sections[0]?.questions[prev.currentIndex + 1].dbSchema,
        ),
        solution:
          prev.data.sections[0]?.questions[prev.currentIndex + 1].solution ||
          "",
        language: [
          {
            value: 1,
            label: "SQL",
          },
        ],
        selectedLanguage: {
          value: 1,
          label: "SQL",
        },
      }));
      // StudentTestPageCxt.setCurrentQnIndex(
      //   StudentTestPageCxt.currentQnIndex + 1
      // );
    }
  };

  return (
    <div className="sqlNaviagatorMainContainer">
      <Button
        size={"sm"}
        onClick={handlePrevious}
        disable={Alert.testDetail.currentIndex === 0}
        icon={{ type: "leading", icon: <ChevronLeft /> }}
        hierarchy={{
          type: "linkColor",
          buttonText: "Prev",
        }}
      />
      <div className="sqlNaviagatorLabelDiv">
        <div
          className={`sqlNaviagatorLabel ${
            Alert.isAdmin && "sqlNaviagatorLabel1"
          }`}
        >
          {Alert.isAdmin ? (
            <>Q:{Alert.testDetail.currentIndex + 1}</>
          ) : (
            <>
              {Alert.testDetail.currentIndex +
                1 +
                " / " +
                Alert.testDetail.totalQn}
            </>
          )}
        </div>
        {Alert.isAdmin && (
          <div className="sqlNavigatorAdmin">
            <div>
              {(Alert.testDetail.data.sections[0].questions[
                Alert.testDetail.currentIndex
              ].actualscore ?? 0) +
                "/" +
                Alert.testDetail.data.sections[0].questions[
                  Alert.testDetail.currentIndex
                ].targetscore}
            </div>
            {Alert.status !== Constants.PROGRESS_STATUS.IN_PROGRESS &&
              Alert.status !== Constants.PROGRESS_STATUS.QN_CONTINUE && (
                <EditIconSvg
                  onClick={
                    [
                      Constants.PROGRESS_STATUS.EVALUATED,
                      Constants.PROGRESS_STATUS.PARTIAL_EVALUATED,
                      Constants.PROGRESS_STATUS.TO_BE_EVALUATED,
                    ].includes(Alert.showBreadCrumbsData.status)
                      ? CodingHeaderAdminSideHks.handleApprove
                      : CodingHeaderAdminSideHks.accessDenied
                  }
                />
              )}
          </div>
        )}
      </div>
      <Button
        size={"sm"}
        onClick={handleNext}
        icon={{ type: "trailing", icon: <AngleRightSvg type={1} sql={true} /> }}
        disable={
          Alert.testDetail.currentIndex ===
          Alert.testDetail.data.sections[0]?.questions.length - 1
        }
        hierarchy={{
          type: "linkColor",
          buttonText: "Next",
        }}
      />
    </div>
  );
}
